import type { Step } from "react-joyride";

export const otRequestFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຫນ້ານີ້ໃຊ້ສົ່ງຄຳຂໍ OT ໃໝ່. ເລືອກວັນທີ່ເຮັດວຽກ, ເວລາເລີ່ມ-ສິ້ນສຸດ ແລະ ເຫດຜົນ (ບໍ່ບັງຄັບ). ຊົ່ວໂມງຄິດໄລ່ອັດຕະໂນມັດ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-request-form-back"]',
    content: "ກັບໄປລາຍການຄຳຂໍ OT. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-request-form-form"]',
    content:
      "ຕື່ມວັນທີ່ເຮັດວຽກ, ເວລາເລີ່ມ-ສິ້ນສຸດ ແລະ ເຫດຜົນ. ສາມາດຕື່ມຕົວຢ່າງໄດ້ ແລ້ວກົດສົ່ງຄຳຂໍ.",
    placement: "top",
  },
];
